export enum NodeKinds {
  ROOT = "ROOT",
  PRODUCT = "PRODUCT",
  FOLDER = "FOLDER",
  WIZARD_ROOT_FOLDER = "WIZARD_ROOT_FOLDER",
  WIZARD_FOLDER = "WIZARD_FOLDER",
  WIZARD_PRODUCT = "WIZARD_PRODUCT",
  WIZARD_COMMISSIONING_COST = "WIZARD_COMMISSIONING_COST",
  TROX_NETCOM_FOLDER = "TROX_NETCOM_FOLDER",
  TROX_NETCOM_PRODUCT = "TROX_NETCOM_PRODUCT",
  TROX_NETCOM_FOLDER_ROOT = "TROX_NETCOM_FOLDER_ROOT",
  TROX_NETCOM_GENERIC_PRODUCT = "TROX_NETCOM_GENERIC_PRODUCT",
  TROX_NETCOM_NOTE = "TROX_NETCOM_NOTE",
  CUSTOM_PRODUCT = "CUSTOM_PRODUCT",
  LINKED_WIZARD_FOLDER = "LINKED_WIZARD_FOLDER",
  LINKED_WIZARD_PRODUCT = "LINKED_WIZARD_PRODUCT",
  PRODUCT_ACCESSORY = "PRODUCT_ACCESSORY",
  WIZARD_PRODUCT_ACCESSORY = "WIZARD_PRODUCT_ACCESSORY",
  XCUBE = "XCUBE",
}
